import PropTypes from 'prop-types';

const footerLinkShape = PropTypes.shape({
  title: PropTypes.string,
  url: PropTypes.string,
  external: PropTypes.bool,
  id: PropTypes.string,
});

const footerLinksShape = PropTypes.oneOfType([
  PropTypes.arrayOf(footerLinkShape),
  footerLinkShape,
]);

const footerShape = PropTypes.shape({
  footerLogos: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    url: PropTypes.string,
  })),
  helpLinks: footerLinksShape,
  aboutLinks: footerLinksShape,
  utilityLinks: footerLinksShape,
  contactUs: footerLinksShape,
});

const smallScreenNavDataV2Shape = PropTypes.shape({
  navigationCategory: PropTypes.shape({
    brandLogoType: PropTypes.string,
    url: PropTypes.string,
    hasSubCategories: PropTypes.bool,
    navigationSubCategories: PropTypes.arrayOf(
      PropTypes.shape({
        categoryId: PropTypes.string.isRequired,
        name: PropTypes.string,
        hasSubCategories: PropTypes.bool,
        navEspotName: PropTypes.shape({
          espotId: PropTypes.string,
          htmlContent: PropTypes.string,
        }),
      }),
    ),
  }),
  footer: footerShape,
});

export default smallScreenNavDataV2Shape;
